module.exports = __webpack_public_path__ + "img/image73.764396b9.png";